import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 5999899F-7FE5-44EF-87F4-DD1E2F9556B3
 * name briefcase-minus
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/briefcase-minus.svg
 * tags
 */
export const BriefcaseMinusIcon = createSvgIcon(<><path d="M22,17V19H14V17H22M10,2H14A2,2 0 0,1 16,4V6H20A2,2 0 0,1 22,8V13.53C20.94,12.58 19.54,12 18,12A6,6 0 0,0 12,18C12,19.09 12.29,20.12 12.8,21H4C2.89,21 2,20.1 2,19V8C2,6.89 2.89,6 4,6H8V4C8,2.89 8.89,2 10,2M14,6V4H10V6H14Z" /></>, 'BriefcaseMinusIcon');
export default BriefcaseMinusIcon